import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "timeout-ring-wrap" }
const _hoisted_2 = {
  class: "timeout-ring",
  viewBox: "0 0 120 120"
}
const _hoisted_3 = ["stroke-dashoffset"]
const _hoisted_4 = { class: "timeout-ring__number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    ($setup.state === 'warning' || $setup.state === 'expired')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "session-timeout-overlay",
          onClick: $setup.onBackdropClick
        }, [
          _createElementVNode("div", {
            class: "session-timeout-card",
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createCommentVNode(" Warning state "),
            ($setup.state === 'warning')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_1, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
                      _cache[3] || (_cache[3] = _createElementVNode("circle", {
                        class: "timeout-ring__track",
                        cx: "60",
                        cy: "60",
                        r: "52",
                        fill: "none",
                        "stroke-width": "6"
                      }, null, -1 /* CACHED */)),
                      _createElementVNode("circle", {
                        class: "timeout-ring__progress",
                        cx: "60",
                        cy: "60",
                        r: "52",
                        fill: "none",
                        "stroke-width": "6",
                        "stroke-linecap": "round",
                        "stroke-dasharray": $setup.circumference,
                        "stroke-dashoffset": $setup.dashOffset
                      }, null, 8 /* PROPS */, _hoisted_3)
                    ])),
                    _createElementVNode("span", _hoisted_4, _toDisplayString($setup.countdown), 1 /* TEXT */)
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "timeout-title" }, "Session Timeout", -1 /* CACHED */)),
                  _cache[5] || (_cache[5] = _createElementVNode("p", { class: "timeout-message" }, " Your session is about to expire due to inactivity. ", -1 /* CACHED */)),
                  _createElementVNode("button", {
                    class: "timeout-btn timeout-btn--primary",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.stayLoggedIn && $setup.stayLoggedIn(...args)))
                  }, " Stay Logged In ")
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createCommentVNode(" Expired state "),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "timeout-icon-wrap" }, [
                    _createElementVNode("svg", {
                      class: "timeout-lock-icon",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("rect", {
                        x: "3",
                        y: "11",
                        width: "18",
                        height: "11",
                        rx: "2",
                        ry: "2"
                      }),
                      _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
                    ])
                  ], -1 /* CACHED */)),
                  _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "timeout-title" }, "Session Expired", -1 /* CACHED */)),
                  _cache[8] || (_cache[8] = _createElementVNode("p", { class: "timeout-message" }, " Your session has expired. Please log in again to continue. ", -1 /* CACHED */)),
                  _createElementVNode("button", {
                    class: "timeout-btn timeout-btn--primary",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.goToLogin && $setup.goToLogin(...args)))
                  }, " Log In ")
                ], 64 /* STABLE_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}